import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { LCDocumentEditor } from './LCDocumentEditor';
import { LectioJSUtils } from './../LectioJSUtils';
import { SelectionDialogs } from './../SelectionDialogs';
import { EditorAttachedFilePlugin } from './EditorAttachedFilePlugin';
import { ILectioPlugin } from './Types';
import { image } from 'd3';
import { LCDialogEditorUtils } from './LCEditorDialogUtils';

export class PluginLectioImage implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectioimage', {
			init: (editorOuter: CKEDITOR.editor) => {
				// editorOuter.filter.allow('img[data-lc-type];img[data-lc-external];img[data-embed-xhtml]', 'lectioEmbed1');
				// editorOuter.filter.allow('img[data-lc-external]', 'lectioEmbed2');

				function getSelectedImageWrapper(editor: CKEDITOR.editor) {
					const sel = editor.getSelection()!;
					const element = sel.getSelectedElement();

					// if ( element && element.is( 'img' ) && !element.data( 'cke-realelement' ) && !element.isReadOnly() )
					if (element && element.hasClass('cke_widget_image') && !element.data('cke-realelement'))
						return element;
					return undefined;
				}

				const imgcmd = LCDocumentEditor.GetEditorEx(editorOuter).commands.image!;
				LectioJSUtils.AssertNotNullOrUndefined(imgcmd, 'imgcmd');
				editorOuter.addCommand('image2original', imgcmd!);

				const lectiocmd: CKEDITOR.commandDefinition = {
					exec: (editor, data) => {
						const imgwrapper = getSelectedImageWrapper(editor);
						if (imgwrapper) {
							// Hvis billedet er mere end et billede, og fx repraesenterer en youtube-video,
							// holder vi snitterne vaek.
							const isLectioComponent = $(imgwrapper.$).find('img[data-lc-type]').length > 0;
							if (isLectioComponent)
								return false;
							return editor.execCommand('image2original', data);
						}

						const editorConfig = LCDocumentEditorUtils.GetEditorConfig(editor);
						const resp = LCDialogEditorUtils.ShowSuitableContentPicker(editor, {
							folderid: SelectionDialogs.InitialFolder.uploadFile
						}, editorConfig);

						resp.promise.then(selection => {
							if (selection == null)
								return;

							let imageInfo: { serializedId: string, filename: string } | null;
							if (selection.type === 'serializedAnyFileId') {
								if (!selection.filename)
									throw new Error('Valgt fil, men navn foelger ikke med? serializedid=' + selection.serializedId);
								const ext = EditorAttachedFilePlugin.GetFilenameExtension(selection.filename);
								const wellKnownImageExtension = ['png', 'jpg', 'jpeg', 'gif'];
								if (ext && wellKnownImageExtension.indexOf(ext) !== -1)
									imageInfo = {
										serializedId: selection.serializedId,
										filename: selection.filename
									};
								else
									imageInfo = null;
							}
							else
								imageInfo = null;

							if (imageInfo) {
								const link = LCDocumentEditorUtils.GetResourceUrl(imageInfo.serializedId, imageInfo.filename);
								EditorAttachedFilePlugin.GetImageSize(link)
									.then(size => {
										if (size == null) {
											console.warn('billede: fik ikke stoerrelse.');
											return;
										}
										const html = `<img src="${link}" width="${size.width}" height="${size.height}" />`;
										const res = LCDialogEditorUtils.ProcessNewHomeworkSelection(editor, {
											type: 'html',
											html: html,
											creationManner: selection.creationManner
										},
											editorConfig.handleHomeworkPickerSelection,
											resp.editorHadFocus);
										if (res === 'client')
											LectioJSUtils.DispatchBrowserTestEvent('lectioimageinserted');
									});
							}
							else {
								LCDialogEditorUtils.ProcessNewHomeworkSelection(
									editorOuter, selection,
									editorConfig.handleHomeworkPickerSelection,
									resp.editorHadFocus);
							}
						});
						return true;
					}
				};

				editorOuter.addCommand('image', $.extend({}, imgcmd, lectiocmd));

				// Vi fjernet image-pluginets "Egenskaber"-kontekstmenupunktet for billeder der ikke blot er billeder, men fx. reprasenterer
				// oembed/youtube-indhold.
				editorOuter.widgets.on('instanceCreated', (evt: { editor: CKEDITOR.editor, data: CKEDITOR.plugins.widget }) => {
					const widget = evt.data;
					if (widget.name !== 'image')
						return;
					widget.on('contextMenu', (evt: { sender: CKEDITOR.plugins.widget, data: { [command: string]: number } }) => {
						const img = LectioJSUtils.GetNotNullValue(evt.sender.parts.image);
						if (img.getName() !== 'img')
							throw new Error('er ikke img?');
						const suppressImagePropertiesContextMenuItem = img.getAttribute('data-lc-type');
						if (suppressImagePropertiesContextMenuItem) {
							if (evt.data.image == null)
								console.warn('lectioimage: kontekstmenu indeholder ikke image?', evt.data);
							delete evt.data.image;
						}
					}, undefined, undefined, 15);
				});
			}
		});
	}
}
